import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

export default function ChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div className="fixed bottom-24 right-6 z-40 w-80 rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden">
          <div className="bg-emerald-500 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2 text-white">
              <MessageCircle size={18} />
              <span className="font-semibold text-sm">Chat with Us</span>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white">
              <X size={18} />
            </button>
          </div>
          <div className="p-4 h-56 bg-slate-50 text-sm text-slate-700">
            <div className="bg-white rounded-lg p-3 shadow-sm mb-2">
              Hi! 👋 Kaise madad kar sakte hain aap ki?
            </div>
            <div className="bg-white rounded-lg p-3 shadow-sm">
              Basic Pass ya Premium Bundle Pass ke bare mein poochh sakte hain.
            </div>
          </div>
          <div className="flex items-center gap-2 border-t border-slate-200 p-2">
            <input
              type="text"
              placeholder="Type a message..."
              className="flex-1 px-3 py-2 rounded-md bg-slate-100 text-slate-800 text-sm outline-none focus:ring-2 focus:ring-emerald-400"
            />
            <button className="w-9 h-9 rounded-md bg-emerald-500 text-white flex items-center justify-center hover:bg-emerald-400 transition-colors">
              <Send size={16} />
            </button>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 flex items-center justify-center shadow-2xl shadow-emerald-500/30 transition-all hover:scale-105"
      >
        {open ? <X className="text-white" size={24} /> : <MessageCircle className="text-white" size={24} />}
      </button>
    </>
  );
}
